import { AdsContextProps } from '@interfaces/Contexts';
import React from 'react';

export const AdsContext = React.createContext<AdsContextProps>({} as AdsContextProps);
